import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                "setu:peer setu:data-[state=checked]:bg-primary setu:data-[state=unchecked]:bg-input setu:focus-visible:!border-ring setu:focus-visible:ring-ring/50 dark:setu:data-[state=unchecked]:bg-input/80 setu:inline-flex setu:!h-[1.15rem] setu:!w-8 setu:shrink-0 setu:items-center setu:rounded-full setu:!border setu:!border-transparent setu:shadow-xs setu:transition-all setu:outline-none setu:focus-visible:ring-[3px] setu:disabled:cursor-not-allowed setu:disabled:opacity-50",
                className
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    "setu:bg-background setu:dark:data-[state=unchecked]:bg-foreground setu:dark:data-[state=checked]:bg-primary-foreground setu:pointer-events-none setu:block setu:size-4 setu:rounded-full setu:ring-0 setu:transition-transform setu:data-[state=checked]:translate-x-[calc(100%-2px)] setu:data-[state=unchecked]:translate-x-0"
                )}
            />
        </SwitchPrimitive.Root>
    );
}

export { Switch };
